import PropTypes from 'prop-types';
import React from 'react';
import { getFormattedName } from '../../shared/nameFormatter';

export class Name extends React.Component {
  render() {
    return (
      <div {...this.props.otherProperties} className="card-name">
        {getFormattedName(this.props.name, this.props.displayLastNameFirst) }
      </div>
    );
  }
}

Name.propTypes = {
  name: PropTypes.object.isRequired,
  displayLastNameFirst: PropTypes.bool,
  otherProperties: PropTypes.object,
};